export const getTouchedFields = (fields: string[]) =>
    fields.reduce(
        (acc, field) => ({
            ...acc,
            [field]: true,
        }),
        {}
    );

// Sample return: { firstName: true, lastName: true }
